import { useQuery } from "@tanstack/react-query";
import { DlqInfoApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { DlqSizeHistory, Stage } from "../lusca-search-api/generated-src";
import { InvestigationApiError, toApiError } from "./useInvestigations";

export const dlqSizeKeys = {
  history: (stage: Stage, days: number) =>
    ["dlq-size-history", stage, days] as const,
};

/**
 * The whole DLQ table's size over time (CloudWatch ItemCount of the DLQ table). The metric moves
 * at most hourly, so it is cached for ten minutes and not refetched on focus.
 */
export function useDlqSizeHistory(stage: Stage, days: number) {
  const api = DlqInfoApiFactory();
  return useQuery<DlqSizeHistory, InvestigationApiError>(
    dlqSizeKeys.history(stage, days),
    async () => {
      try {
        return (await api.getDlqSizeHistory(stage, days)).data;
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal -- same error shape as the investigation hooks
        throw toApiError(error);
      }
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000,
      keepPreviousData: true,
    }
  );
}
